//import {axiosClient} from '../../main'
import Vue from 'vue'
//import axios from '../../http/axios/index.js'

export default {
  addTag ({ commit }, tag) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('/tags/add/', {tag})
        .then((response) => {
          commit('ADD_TAG', Object.assign(response.data.data[0]))
          resolve(response)     
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTags ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/tags/all')
        .then((response) => {
          commit('SET_TAG', response.data.data.tags)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateTag ({ dispatch }, tag) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`/tags/update/${tag.id}`, {tag})
        .then((response) => {
          //commit('UPDATE_PRODUCT', response.data.data.products)
          dispatch('fetchTags')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeTag ({ commit }, tagId) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.delete(`/tags/remove/${tagId}`)
        .then((response) => {
          commit('REMOVE_TAG', tagId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
